import { AppConnectionStatuses } from 'integrations-lib/constants/appConnectionStatuses';
import { DashworksServiceComponent } from './DashworksServiceComponent';
export const DashworksReconnectionConfig = {
  statusesForDisplaying: [AppConnectionStatuses.UPDATE_AVAILABLE, AppConnectionStatuses.DISCONNECTED],
  serviceComponent: DashworksServiceComponent
};